import React, { useEffect } from 'react';
import { Row, Col, Button } from "reactstrap";
import MarketTable from './MarketTable';
import AddMarketModal from './AddMarketModal';
import EditMarketModal from './EditMarketModal';
import DeleteMarketModal from "./DeleteMarketModal";
import { useDispatch, useSelector } from 'react-redux';
import { toggleAddMarketModal } from '../../../../slices/modals/reducer';
import { useLocation, useParams } from 'react-router-dom';
import { createSelector } from 'reselect';
import { setInnerPreloader } from '../../../../slices/layouts/reducer';
import { getBrandList, getClientList, getMarketList } from '../../../../slices/auth/settings/thunk';
import { replace } from 'redux-first-history';
import { getBrandSuccess, getMarketSuccess } from '../../../../slices/auth/settings/reducer';
import { setBrandPath, setClientPath } from '../../../../slices/auth/menu/thunk';
import { setBreadcrumb } from '../../../../slices/auth/menu/reducer';
import MarketActivateModal from './ActivateMarketModal';

/**
 * React component for managing market-related functionality and rendering.
 * @component
 */
function Market() {
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();

  const selectStates = createSelector(state => state, state => ({
    company: state.MenuData.client,
    previousLocations: state.router.previousLocations,
    title: state.MenuData.title
  }));
  const { company, previousLocations, title } = useSelector(selectStates);

  useEffect(() => {
    if (previousLocations[0].location.state === null && (previousLocations[0].action === "PUSH" || previousLocations[0].action === "POP") && company !== null) {
      dispatch(setInnerPreloader(true));
      dispatch(getClientList()).then(client => {
        const matchedClient = client.payload.find(
          item => item.clientName.toLowerCase().replaceAll(/\s+/g, "-") === params.client
        );
        if (matchedClient) {
          dispatch(setClientPath(matchedClient._id));
          dispatch(getBrandList(matchedClient._id)).then(brand => {
            const matchedBrand = brand.payload.find(
              item => item.name.toLowerCase().replaceAll(/\s+/g, "-") === params.brand
            );
            if (matchedBrand) {
              dispatch(setBrandPath(matchedBrand._id));
              dispatch(getMarketList(matchedBrand._id)).then(res => {
                const pathnameSplit = location.pathname.split('/');
                const companySrc = `/${pathnameSplit[1]}/${pathnameSplit[2]}`;
                const clientSrc = `/${pathnameSplit[1]}/${pathnameSplit[2]}/${pathnameSplit[3]}`;
                const brandSrc = `/${pathnameSplit[1]}/${pathnameSplit[2]}/${pathnameSplit[3]}/${pathnameSplit[4]}`;
                dispatch(replace(location.pathname, {
                  markets: res.payload, brands: brand.payload, clientId: matchedClient._id, brandId: matchedBrand._id, title: [
                    { name: 'Company Details', src: companySrc },
                    { name: matchedClient.clientName, src: clientSrc },
                    { name: matchedBrand.name, src: brandSrc },
                  ]
                }));
                dispatch(setInnerPreloader(false));
              })
            }
          });
        }
      });
    } else if (previousLocations[0].location.state !== null) {
      dispatch(getMarketSuccess(previousLocations[0].location.state.markets));
      dispatch(getBrandSuccess(previousLocations[0].location.state.brands));
      dispatch(setClientPath(previousLocations[0].location.state.clientId));
      dispatch(setBrandPath(previousLocations[0].location.state.brandId));
      dispatch(setBreadcrumb({ pageTitle: 'Settings', title: previousLocations[0].location.state.title }))
    }
  }, [location])
  return (
    <div>
      <Row>
        <Col className="col-sm-6">
          <div>

          </div>
        </Col>
        <Col className="col-sm-6">
          <div className="d-flex justify-content-end">
            <Button color="info" className="add-btn" id="create-btn" onClick={() => dispatch(toggleAddMarketModal())}>
              <i className="ri-add-line align-bottom"></i> Add Market
            </Button>
          </div>
        </Col>
      </Row>
      <MarketTable />
      <AddMarketModal />
      <EditMarketModal />
      <DeleteMarketModal />
      <MarketActivateModal />
    </div>
  )
}

export default Market;